// extracted by mini-css-extract-plugin
export var label = "_d0-2";
export var slideContainer = "_d0-0";
export var slider = "_d0-1";